import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getPurchasePriceStock = api.injectEndpoints({
  endpoints: builder => ({
    getPurchasePriceStock: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/pdf/product-catalog-purchase-price-stock`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{}>;

export const {useLazyGetPurchasePriceStockQuery} = getPurchasePriceStock;
